var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 336,
    viewBox: "0 0 512 336",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512.001 70.897H0V9.103A8.829 8.829 0 0 1 8.828.275h494.345a8.829 8.829 0 0 1 8.828 8.828v61.794zm-8.829 264.827H8.828A8.829 8.829 0 0 1 0 326.896v-61.793h512v61.793a8.828 8.828 0 0 1-8.828 8.828z",
    fill: "#FF4B55"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#41479B",
    d: "M0 70.897h512v194.207H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F5F5F5",
    cx: 256,
    cy: 168,
    r: 70.621
  }))));
}

export default "data:image/svg+xml,export default 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTEyIiBoZWlnaHQ9IjMzNiIgdmlld0JveD0iMCAwIDUxMiAzMzYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGcgZmlsbD0ibm9uZSI+CiAgICA8cGF0aCBkPSJNNTEyLjAwMSA3MC44OTdIMFY5LjEwM0E4LjgyOSA4LjgyOSAwIDAgMSA4LjgyOC4yNzVoNDk0LjM0NWE4LjgyOSA4LjgyOSAwIDAgMSA4LjgyOCA4LjgyOHY2MS43OTR6bS04LjgyOSAyNjQuODI3SDguODI4QTguODI5IDguODI5IDAgMCAxIDAgMzI2Ljg5NnYtNjEuNzkzaDUxMnY2MS43OTNhOC44MjggOC44MjggMCAwIDEtOC44MjggOC44Mjh6IiBmaWxsPSIjRkY0QjU1Ii8+CiAgICA8cGF0aCBmaWxsPSIjNDE0NzlCIiBkPSJNMCA3MC44OTdoNTEydjE5NC4yMDdIMHoiLz4KICAgIDxjaXJjbGUgZmlsbD0iI0Y1RjVGNSIgY3g9IjI1NiIgY3k9IjE2OCIgcj0iNzAuNjIxIi8+CiAgPC9nPgo8L3N2Zz4K'";
export { SvgLa as ReactComponent };